import { TsDOM as q } from '@/scripts/core/TsDOM'
import { type CartItems } from '@/scripts/cart/cart-items'
import { type CartDrawerItems } from '@/scripts/cart/cart-drawer-items'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class CartRemoveButton extends UcoastEl {
	static htmlSelector = 'cart-remove-button'
	constructor() {
		super()

		this.addEventListener('click', this.removeItem.bind(this))
	}

	removeItem() {
		const cartItems = q.oc<CartItems>(this, 'cart-items') || q.rc<CartDrawerItems>(this, 'cart-drawer-items')
		const line = q.ra(this, 'data-index')
		const groupItemKeys = q.oa(this, 'data-group-item-keys')

		if (groupItemKeys) {
			const updates = groupItemKeys
				.split(',')
				.map((key) => key.trim())
				.filter(Boolean)
				.reduce<Record<string, number>>((acc, key) => {
					acc[key] = 0
					return acc
				}, {})

			cartItems.updateItemsByKey(line, updates)
			return
		}

		cartItems.updateQuantity(line, '0')
	}
}
